const STATUS_NOT_FOUND = 404;

export {STATUS_NOT_FOUND};
